var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTeam(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 14.066,
    height: 14.068,
    viewBox: "0 0 14.066 14.068",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:url(#a);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#074673"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#41a1c8"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.469 -0.463)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M13.551,9.267,11.666,8.034,12.392,6.7a2.318,2.318,0,0,0,.267-1.078V3.516A3.045,3.045,0,0,0,7.544,1.275l.637.688a2.109,2.109,0,0,1,3.541,1.553V5.625a1.371,1.371,0,0,1-.153.628l-1.14,2.091,2.609,1.707a1.235,1.235,0,0,1,.559,1.038v1.567H11.488v.938h3.047V11.089a2.17,2.17,0,0,0-.983-1.822Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M9.332,10.2,7.447,8.971,8.173,7.64A2.318,2.318,0,0,0,8.44,6.563V4.454a3.047,3.047,0,1,0-6.094,0V6.562A2.285,2.285,0,0,0,2.61,7.639l.73,1.338L1.466,10.2a2.169,2.169,0,0,0-.983,1.819L.469,14.531h9.846V12.026A2.17,2.17,0,0,0,9.332,10.2Zm.045,3.39H1.412l.009-1.568a1.235,1.235,0,0,1,.559-1.038l2.6-1.7-1.144-2.1a1.372,1.372,0,0,1-.15-.628V4.454a2.109,2.109,0,1,1,4.219,0V6.563a1.371,1.371,0,0,1-.153.628L6.21,9.281l2.609,1.707a1.235,1.235,0,0,1,.559,1.038Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeam);
export default __webpack_public_path__ + "static/media/team.58d655c8496dd78733037e8c3041c4a4.svg";
export { ForwardRef as ReactComponent };